<template>
  <div>
    <Qrcode @onDetect="onDetect"></Qrcode>
  </div>
</template>

<script>
import  Qrcode  from "@/components/Qrcode"

export default {
  name: "Scanner",
  components: {
    Qrcode
  },
  methods: {
    onDetect (val) {
      if (val && val.result) {
        window.location.href = val.result
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style scoped>

</style>